module.exports = __webpack_public_path__ + "static/media/fingerPointI.1642440d.svg";